<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('SalesPersonAgents') + salePersonName"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row mb-6" v-has-permission="permission59">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("Agent") }}</label>
            <treeselect
              name="agent"
              :multiple="false"
              :placeholder="$t('SearchAgent')"
              :async="true"
              :load-options="loadOptions"
              v-validate="'required'"
              class="search-input"
              ref="agent"
              @select="onAgentSelected"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn"
              @click.prevent="addAgentInfo()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('Firstname') },
          { title: $t('Lastname') },
          { title: $t('CompanyName') },
          { title: $t('CompanyNationalId') },
          { title: $t('EconomicCode') },
          { title: $t('SocialSecurityNumber') },
          { title: $t('AgentType') },
          { title: $t('IsActive') },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 11%">
            <span v-if="row.firstName">{{ row.firstName }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 12%">
            <span v-if="row.lastName">{{ row.lastName }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 11%">
            <span v-if="row.companyName">{{ row.companyName }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 10%">
            <span v-if="row.companyNationalId">{{
              row.companyNationalId
            }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 10%">
            <span v-if="row.economicCode">{{ row.economicCode }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 10%">
            <span v-if="row.socialSecurityNumber">{{
              row.socialSecurityNumber
            }}</span>
            <span v-else>-</span>
          </td>
          <td style="width: 8%">
            <span v-if="row.agentType == '0'">{{ $t("Legal") }}</span>
            <span v-if="row.agentType == '1'">{{ $t("Individual") }}</span>
          </td>
          <td style="width: 5%">
            <vs-checkbox v-model="row.isActive" disabled>{{
              $t("Active")
            }}</vs-checkbox>
          </td>
          <td style="width: 19%; text-align: left !important">
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-edit"
              class="bordered-btn"
              @click.prevent="segmentAgentPopup(row)"
              v-has-permission="permission57"
              >{{ $t("ProductSegments") }}</vs-button
            >
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignAgent(row.agentId)"
              v-has-permission="permission58"
              class="d-inline"
            ></vs-button>
          </td>
        </template>
      </data-grid>
      <agent-segment-popup
        :show="showAgentSegmentPopup"
        :agentSegmentModel="agentSegmentModel"
        @finish="onAgentSegmentModalfinish"
      ></agent-segment-popup>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import AgentSegmentPopup from "./AgentSegmentPopup.vue";
const dict = {
  custom: {
    product: {
      required: "لطفا محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SalesPersons_AgentPopup",

  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },

  data() {
    return {
      permission57: "GetAllAgentSegmentInfos",
      permission58: "RemoveAgentInfoFromSalePerson",
      permission59: "AddAgentInfoToSalePerson",
      gridDataSource: { data: [] },
      gridSearchData: {},
      agentInfo: {},
      agentSegmentModel: {
        salePersonId: null,
        agentId: null,
        agentName: "",
      },
      showAgentSegmentPopup: false,
      salePersonName: "",
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      assignAgentInfo: "sale/attachAgentInfo",
      fetchSearch: "parties/channelAgentsSearch",
      unassignAgentInfo: "sale/unassignAgentInfo",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onAgentSelected(data) {
      this.agentInfo.agentId = data.id;
    },
    addAgentInfo() {
      this.agentInfo.salePersonId = this.model.salePersonId;
      this.assignAgentInfo(this.agentInfo).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "رکورد مورد نظر با موفقیت اضافه شد!",
          color: "success",
        });
        this.$refs.grid.renderGrid();
      });
      this.$refs.agent.clear();
    },
    unassignAgent(agentId) {
      var salePersonId = this.model.salePersonId;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignAgentInfo({ salePersonId, agentId }).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    segmentAgentPopup(model) {
      this.agentSegmentModel.salePersonId = this.model.salePersonId;
      this.agentSegmentModel.agentId = model.agentId;
      this.showAgentSegmentPopup = true;
      if (model.firstName || model.lastName) {
        this.agentSegmentModel.agentName =
          model.firstName + " " + model.lastName;
      } else if (model.companyName) {
        this.agentSegmentModel.agentName = model.companyName;
      }
    },
    onAgentSegmentModalfinish() {
      this.showAgentSegmentPopup = false;
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.salePersonName) {
          this.salePersonName = ": " + this.model.salePersonName;
        } else {
          this.salePersonName = "";
        }
        this.$validator.reset();
        this.agentInfo.salePersonId = this.model.salePersonId;
        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SalePersonQuery/" +
            this.model.salePersonId +
            "/AgentInfo",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        this.$refs.agent.clear();
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    Treeselect,
    DataGrid,
    "v-select": vSelect,
    AgentSegmentPopup,
  },
};
</script>
